export class Article {
  constructor(
    public route: string,
    public title: string,
    public standfirst: string,
    public authorName: string,
    public date: Date | null,
    public mainImage: string,
    public timeToRead: number) {
  }

  get dateString() {
    return this.date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  }
}
